import { TOAST_NOTIFICATION_TYPES } from './toastNotificationTypes';

export const TOAST_NOTIFICATION_MESSAGES = {
  [TOAST_NOTIFICATION_TYPES.EVENT_COMMENT_ADDED]: 'New comment by {reporterName} on {orgUnitNames}',
  [TOAST_NOTIFICATION_TYPES.EVENT_COMMENT_EDITED]:
    'Edited comment by {reporterName} on {orgUnitNames}',
  [TOAST_NOTIFICATION_TYPES.EVENT_MOVED_TO_READY_TO_DELIVER]:
    '{orgUnitNames} Event has successfully moved to the Ready to Deliver stage',
  [TOAST_NOTIFICATION_TYPES.EVENT_CONFIRM_ASSIGNMENT]: '{reporterName} Confirmed Assignment',
  [TOAST_NOTIFICATION_TYPES.EVENT_DECLINE_ASSIGNMENT]:
    '{reporterName} Declined Assignment due to Date and/or Region change',
  [TOAST_NOTIFICATION_TYPES.EVENT_SUBMITTED]: 'Event {orgUnitNames} is pending admin review.',
  [TOAST_NOTIFICATION_TYPES.EVENT_ATL_OBSERVER_ASSIGNED]:
    "You've been assigned as an {observerType} for {atlName}. Accept or decline assignment in the event.",
  [TOAST_NOTIFICATION_TYPES.EVENT_ATL_OBSERVER_UNASSIGNED]:
    "You've been unassigned as an {observerType} for the event.",
  [TOAST_NOTIFICATION_TYPES.EVENT_ATL_OBSERVABLE_UNASSIGNED]:
    '{atlName} has been unassigned as an {atlCurrentRoleName} from the event.',
  [TOAST_NOTIFICATION_TYPES.INVALID_FILE]: 'Unable to upload file',
  [TOAST_NOTIFICATION_TYPES.EVENT_ATM_OBSERVER_ASSIGNED]:
    "You've been assigned as an {observerType} for {atmName}. Accept or decline assignment in the event.",

  [TOAST_NOTIFICATION_TYPES.USER_ASSIGNED_TO_FUTURE_EVENT]:
    '{firstName} {lastName} is assigned to Event # {eventId}. Remove the user from event before user license can be Deactivated from {orgUnitName}.',
  [TOAST_NOTIFICATION_TYPES.USER_INVITED_TO_FUTURE_EVENT]:
    '{firstName} {lastName} is invited to Event # {eventId}. Remove the user from event before user license can be Deactivated from {orgUnitName}.',

  [TOAST_NOTIFICATION_TYPES.ORG_UNIT_DEACTIVATED_AND_EVENT_GOT_REMOVED]:
    'Org Unit {orgUnitName} has been deactivated and Event # {eventId} has been removed from the Calendar.',
  [TOAST_NOTIFICATION_TYPES.ORG_UNIT_DEACTIVATED_AND_REMOVED_FROM_MULTI_SITE_EVENT]:
    'Org Unit {orgUnitName} has been deactivated and removed from Event # {eventId}.',
  [TOAST_NOTIFICATION_TYPES.OBSERVATION_REPORT_SUBMITTED]:
    'Observation/Coaching Report has been submitted'
};
